import axios from "axios";
import qs from "qs";
//将所有的主机名和端口 一起设置
// axios.defaults.baseURL = "crmapi.kidcastle.org";
import Urls from "../../urlLink";
import {isGraySchoolEnabled} from "@/bootstrap/graySchoolRouting";
const root = Urls.crmApiUrl; //域名
//首页数据请求
const url = {
  getHome: root + "/Intentionclient/home",
  getHomeExport:root+"/Intentionclient/home/Export",
  applyChannelAction: root + "/Client/applyChannelAction",
  getChannelTrack: root + "/Client/getChannelTrack",
  getChannellogList: root + "/Client/getChannellogList",
  changeIntentionClient: root + "/Intentionclient/changeIntentionClientApi",
  changeIntentionClientApi: root + "/Intentionclient/changeIntentionClientApi",
  getSource: root + "/Public/getSourceApi",
  getMarketer: root + "/Public/getMarketerApi",
  getIntentCourse: root + "/Public/getIntentCourseApi",
  addIntentionclient: root + "/Intentionclient/addIntentionclientAction",
  checkIntentionClient: root + "/Intentionclient/checkIntentionClientApi",
  getFamilyRelation: root + "/Public/getFamilyRelationApi",
  getFriendRelation: root + "/Public/getFriendRelationApi",
  getClientName: root + "/Client/getClientNameApi",
  bindingClient: root + "/Client/bindingClientAction",
  settingtrackClient: root + "/Client/trackClientAction",
  editClient: root + "/Client/editClientAction",
  delFamilyRelation: root + "/Public/delFamilyRelationApi",
  delIntentionSource: root + "/Public/delIntentionSourceApi",
  getclientOne: root + "/Client/clientOneApi",
  getActivity: root + "/Client/getActivityApi",
  getOrderFieldApi: root + "/Intentionclient/getOrderFieldApi", //获取意向客户排序字段

  conversionCourseApi: root + "/Intentionclient/conversionCourseApi", //意向客户->CRM获取转正课程
  conversionAction: root + "/Intentionclient/conversionAction", //意向客户->CRM转正客户

  clientOneTrackApi: root + "/Client/clientOneTrackApi",

  // 招生录音需求
  getLabelApi: root + "/Public/getLabelApi", //获取客户标签-wgh
  addClientTagsAction: root + "/Client/addClientTagsAction", //添加客户标签-wgh
  getDialRecord: root + "/Client/getDialRecord", //获取待拨打/已通话列表-wgh
  addClientDialRecordAction: root + "/Client/addClientDialRecordAction", //添加待拨打-wgh
  dialrecordList: root + "/Client/dialrecordList", //拨打记录管理-wgh

  // 更新电话接通状态
  updateClientAnswerPhoneAction: root + "/Client/updateClientAnswerPhoneAction",
  changeLossClientTmkApi: root + "/Lossclient/changeLossClientTmkApi",

  getOneTmkClient: root + "/Intentionclient/getOneTmkClient",
  getOneTmkClientRecord: root + "/Intentionclient/getOneTmkClientRecord",
  changeClientToValidApi: root + "/Client/changeClientToValidApi",
  getTmkMarketerApi: root + "/Public/getTmkMarketerApi",
  inviteTimetableApi: root + "/Timetable/inviteTimetableApi",
  courseTypeApi: root + "/Public/courseTypeApi",
  getClientStudentApi: root + "/Client/getClientStudentApi", //招生有效名单->获取可选推荐人-lujing
  getReMarketerApi: root + "/Public/getReMarketerApi",
  callClientMobileAction: root + "/Intentionclient/callClientMobileAction",
  getIntentionNum: root + "/Intentionclient/getIntentionNum",

  getClientConflicts: root + "/Client/getClientConflicts", // 名单撞单记录
  getClientConflictsExport: root + "/Client/getClientConflicts/Export", // 名单撞单记录
  getClientConflictsOne: root + "/Client/getClientConflictsOne", // 名单撞单 - 单条详情
  getClientConflictsMobileRepeat:
    root + "/Client/getClientConflictsMobileRepeat", // 名单撞单 - 重复手机号名单
};
const storeCustoMersmanage = {
  getClientConflicts(params) {
    return axios.get(url.getClientConflicts, { params });
  },
  getClientConflicts1() {
    return  isGraySchoolEnabled() ? url.getClientConflictsExport: url.getClientConflicts;
  },
  getIntentionNum(params) {
    return axios.get(url.getIntentionNum, { params });
  },
  getClientConflictsMobileRepeat(params) {
    return axios.get(url.getClientConflictsMobileRepeat, { params });
  },
  getClientConflictsOne(params) {
    return axios.get(url.getClientConflictsOne, { params });
  },
  getClientStudentApi(params) {
    return axios.get(url.getClientStudentApi, { params });
  },
  //意向客户管理
  getHome(params) {
    return axios.get(url.getHome, {
      params,
    });
  },
  applyChannelAction(params) {
    return axios.post(url.applyChannelAction, qs.stringify(params));
  },
  getChannelTrack(params) {
    return axios.get(url.getChannelTrack, {
      params,
    });
  },
  getChannellogList(params) {
    return axios.get(url.getChannellogList, {
      params,
    });
  },
  //意向客户管理--导出
  getHome1() {
    return isGraySchoolEnabled() ? url.getHomeExport: url.getHome;
  },
  // 获取招生渠道类型
  getSource(params) {
    return axios.get(url.getSource, {
      params,
    });
  },
  // 获取意向客户排序字段
  getOrderFieldApi(params) {
    return axios.get(url.getOrderFieldApi, {
      params,
    });
  },
  // 获取活动名称
  getActivity(params) {
    return axios.get(url.getActivity, {
      params,
    });
  },
  // 获取招生的负责人
  getMarketer(params) {
    return axios.get(url.getMarketer, {
      params,
    });
  },
  //获取意向课程
  getIntentCourse(params) {
    return axios.get(url.getIntentCourse, {
      params,
    });
  },
  // 获取家庭亲属关系
  getFamilyRelation(params) {
    return axios.get(url.getFamilyRelation, {
      params,
    });
  },
  // 获取绑定关系
  getFriendRelation(params) {
    return axios.get(url.getFriendRelation, {
      params,
    });
  },
  // 绑定学员->获取人员名称
  getClientName(params) {
    return axios.get(url.getClientName, {
      params,
    });
  },
  // 招生目标线索->绑定学员
  bindingClient(params) {
    return axios.post(url.bindingClient, qs.stringify(params));
  },
  // 招生目标线索->跟进客户
  settingtrackClient(params) {
    return axios.post(url.settingtrackClient, qs.stringify(params));
  },
  // 获取单个客户的基本信息
  getclientOne(params) {
    return axios.get(url.getclientOne, {
      params,
    });
  },
  // 意向客户管理->新增时-检测重名
  checkIntentionClient(params) {
    return axios.get(url.checkIntentionClient, {
      params,
    });
  },
  // 意向客户->CRM获取转正课程
  conversionCourseApi(params) {
    return axios.get(url.conversionCourseApi, {
      params,
    });
  },
  // 意向客户->CRM转正客户
  conversionAction(params) {
    return axios.post(url.conversionAction, qs.stringify(params));
  },
  // 新增意向客户
  addIntentionclient(params) {
    return axios.post(url.addIntentionclient, qs.stringify(params));
  },
  // 编辑意向客户
  editClient(params) {
    return axios.post(url.editClient, qs.stringify(params));
  },
  // 删除亲属关系
  delFamilyRelation(params) {
    return axios.post(url.delFamilyRelation, qs.stringify(params));
  },
  // 删除意向课程
  delIntentionSource(params) {
    return axios.post(url.delIntentionSource, qs.stringify(params));
  },
  // 转为招生线索或无意向
  changeIntentionClient(params) {
    return axios.post(url.changeIntentionClient, qs.stringify(params));
  },
  changeIntentionClientApi(params) {
    return axios.post(url.changeIntentionClientApi, qs.stringify(params));
  },
  clientOneTrackApi(params) {
    return axios.get(url.clientOneTrackApi, {
      params,
    });
  },
  // 招生录音需求
  getLabelApi(params) {
    return axios.get(url.getLabelApi, {
      params,
    });
  },
  addClientTagsAction(params) {
    return axios.post(url.addClientTagsAction, qs.stringify(params));
  },
  getDialRecord(params) {
    return axios.get(url.getDialRecord, {
      params,
    });
  },
  addClientDialRecordAction(params) {
    return axios.post(url.addClientDialRecordAction, qs.stringify(params));
  },
  dialrecordList(params) {
    return axios.get(url.dialrecordList, {
      params,
    });
  },
  updateClientAnswerPhoneAction(params) {
    return axios.post(url.updateClientAnswerPhoneAction, qs.stringify(params));
  },
  changeClientToValidApi(params) {
    return axios.post(url.changeClientToValidApi, qs.stringify(params));
  },
  callClientMobileAction(params) {
    return axios.get(url.callClientMobileAction, {
      params,
    });
  },
  getOneTmkClient(params) {
    return axios.get(url.getOneTmkClient, {
      params,
    });
  },
  getOneTmkClientRecord(params) {
    return axios.get(url.getOneTmkClientRecord, {
      params,
    });
  },
  getTmkMarketerApi(params) {
    return axios.get(url.getTmkMarketerApi, {
      params,
    });
  },
  inviteTimetableApi(params) {
    return axios.get(url.inviteTimetableApi, {
      params,
    });
  },
  changeLossClientTmkApi(params) {
    return axios.post(url.changeLossClientTmkApi, qs.stringify(params));
  },
  // 获取班组下拉
  courseTypeApi(params) {
    return axios.get(url.courseTypeApi, {
      params,
    });
  },
  getReMarketerApi(params) {
    return axios.get(url.getReMarketerApi, {
      params,
    });
  },
};

export default storeCustoMersmanage;
